const SET_CMS_COMPONET_DATA = 'SET_CMS_COMPONET_DATA';
const SET_CMS_COMPONET_INNER_DATA = 'SET_CMS_COMPONET_INNER_DATA';

export {
    SET_CMS_COMPONET_DATA, SET_CMS_COMPONET_INNER_DATA
};
